import createApp from '@/create-app'
// config
import App from './app'
import config from './config'

// init
createApp(App, config)